// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AccessBody component
 */
!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var AccessGrid = require('modules/Access/Izenda.AccessGrid');
  var CONSTANT = require('logic/data/Izenda.AccessConstants');
  var actions = require('./Izenda.AccessBodyAction');

  var AccessBody = React.createClass({

    /**
     * render component
     * @return {Object} react component
     */
    render: function () {
      var props = this.props;
      var store = props.store;

      return (
        <AccessGrid
          isGlobal={store.model.isGlobal}
          store={store.accessStore}
          users={store.accessStore.users}
          roles={store.accessStore.roles}
          tableDef={CONSTANT.ACCESS_TABLE_DEF}
          searchOptions={CONSTANT.SEARCH_OPTIONS}
          accessMode={CONSTANT.ACCESS_MODE.REPORT}
          userModeType={CONSTANT.USER_ACCESS_MODE.ACCESS}/>
      );
    }
  });

  module.exports = connect(actions)(AccessBody);
} ());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Access/Izenda.AccessBody.jsx